import React, { useState, useEffect } from "react";
import { ClockIcon } from "@heroicons/react/24/outline";

export default function LiveElapsedTimer({ checkInDate }) {
  const [elapsed, setElapsed] = useState("00:00:00");

  useEffect(() => {
    if (!checkInDate) return;

    const updateTimer = () => {
      const diffMs = new Date() - checkInDate;
      if (diffMs <= 0) {
        setElapsed("00:00:00");
        return;
      }
      const diffSecs = Math.floor(diffMs / 1000);
      const h = Math.floor(diffSecs / 3600);
      const m = Math.floor((diffSecs % 3600) / 60);
      const s = diffSecs % 60;
      setElapsed(
        [
          String(h).padStart(2, "0"),
          String(m).padStart(2, "0"),
          String(s).padStart(2, "0"),
        ].join(":")
      );
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [checkInDate]);

  return (
    <div className="text-center py-3 px-4 rounded-2xl bg-emerald-50/70 border border-emerald-200/70 my-4 shadow-2xs font-sans">
      <p className="text-[10px] font-bold text-emerald-700 tracking-wider uppercase flex items-center justify-center gap-1">
        <ClockIcon className="w-3.5 h-3.5 text-emerald-600" />
        Time On Site
      </p>
      <p className="text-4xl font-mono font-black tracking-widest text-emerald-900 mt-1">
        {elapsed}
      </p>
    </div>
  );
}
